import React from 'react';
import 'style/Header.css'
import ArrowForwardIosRoundedIcon from '@material-ui/icons/ArrowForwardIosRounded';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import utils from 'Utils'
import jMoment from 'moment-jalaali'
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import ConsultTimerModal from 'components/ConsultTimerModal'


class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showBackButton: this.props.showBackButton === undefined ? true : this.props.showBackButton,
      showMenu: this.props.showMenu || false,
      desc: this.props.desc,
      redirect: '',
      roomId: this.props.roomId,
      enableAlertButton: false,
      time: { m: '- -', s: '- -' },
      seconds: 1800,
      maxSecond: 1800,
      showTimer: false,
      timerLoading: false,
    }

    this.counter = 0
  }

  disableAlertDoctorButton = () => {
    if (!window.localStorage.getItem(this.props.consultRequest.roomId))
      return this.setState({ enableAlertButton: true, seconds: this.state.maxSecond })

    const buttonInfo = JSON.parse(window.localStorage.getItem(this.props.consultRequest.roomId))
    const now = jMoment(new Date)
    const timeClickedAlertDoctorButton = jMoment(buttonInfo.date)
    const diff = now.diff(timeClickedAlertDoctorButton, 'seconds')
    const remainTime = this.state.maxSecond - diff

    if (remainTime > 0) {
      this.setState({ seconds: remainTime, showTimer: true })
      if (this.counter === 0) this.counter = setInterval(this.startTimer, 1000)
    } else {
      window.localStorage.removeItem(this.props.consultRequest.roomId)
      this.setState({ seconds: this.state.maxSecond, showTimer: false })
    }
  }

  startTimer = () => {
    let seconds = this.state.seconds - 1
    this.secondsToTime(seconds)
    this.setState({
      time: this.secondsToTime(this.state.seconds),
      seconds,
    });
  }

  secondsToTime = secs => {
    let divisor_for_minutes = secs % (60 * 60)
    let minutes = Math.floor(divisor_for_minutes / 60)

    let divisor_for_seconds = divisor_for_minutes % 60
    let seconds = Math.ceil(divisor_for_seconds)

    let obj = {
      "m": minutes < 10 ? '0' + minutes : minutes,
      "s": seconds < 10 ? '0' + seconds : seconds
    }

    return obj
  }

  openAlertDoctorModal = () => {
    this.ConsultTimerModal.openModal()
  }

  apiAlertDoctor = async () => {
    this.setState({ timerLoading: true })

    let res = await utils.iaxios({
      method: 'POST',
      url: utils.urls.notifyDoctor,
      data: { consultId: this.props.consultRequest.id }
    }, true)
      .catch((e) => {
        console.log(e.response)
        let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
        this.props.openSnackbar(message)
        this.setState({ timerLoading: false })
      })

    if (!res) return
    if (!res.data.success) return this.props.openSnackbar('خطایی رخ داده است')

    this.props.openSnackbar(res.data.message, 'info')

    const { consultRequest: { roomId } } = this.props
    window.localStorage.setItem(roomId, JSON.stringify({ disable: true, date: new Date }))

    if (this.counter === 0) this.counter = setInterval(this.startTimer, 1000)

    this.setState({ showTimer: true, timerLoading: false })

    this.disableAlertDoctorButton()
  }

  render() {
    return (
      <header class="header" style={this.props.style}>
        {this.state.showBackButton ? <div class="backHeader" onClick={this.props.onBack || utils.goBack}><ArrowForwardIosRoundedIcon /></div> : null}
        <h1>
          {this.props.title}
          {this.state.desc && <span>{this.state.desc}</span>}
        </h1>
        {this.props.consultRequest && this.props.consultRequest.type === 'text' && this.props.consultRequest.status=='asigned' &&
          <div className="alertDoctor" onClick={this.openAlertDoctorModal}>

            <NotificationsActiveIcon style={{ marginLeft: 5, fontSize: 18, color: '#e77d7d' }} />
            <span>دکتر را خبر کن</span>

          </div >
        }
        {this.state.showMenu ? <MoreVertIcon onClick={this.state.showMenu}></MoreVertIcon> : null}
        { (this.props.consultRequest && this.props.consultRequest.roomId) &&
          <ConsultTimerModal
            ref={el => this.ConsultTimerModal = el}
            consultRequest={this.props.consultRequest}
            openSnackbar={this.props.openSnackbar}
          />
        }
      </header>
    );
  }
}
export default Header;
